<template>
  <div>

    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vs-card>
          <div slot="header">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="m-3">
                Umowa z {{ agreement.bank }} z {{ agreement.created_at | date }}.
              </h3>
              <span class="d-flex align-items-center">
                <span class="m-3">
                 <vs-switch v-model="showAllPages" style="width: 150px">
                  <template #on>
                    Schowaj strony bez klauzul
                  </template>
                  <template #off>
                    Pokaż wszystkie strony
                  </template>
                  </vs-switch>
                </span>
                <span class="m-3 agreement-id" title="Identyfikator umowy">{{ id }}</span>
              </span>
            </div>
          </div>
          <div style="font-size: 14px; line-height: 27px; text-align: justify" class="m-3">
            <div class="vx-row">
              <div class="vx-col w-full sm:w-1/2">
                <table>
                  <tbody>
                  <tr>
                    <td>{{ agreement.name }} {{ agreement.surname }}</td>
                  </tr>
                  <tr>
                    <td>{{ agreement.phone }}</td>
                  </tr>
                  <tr>
                    <td>{{ agreement.email }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="vx-col w-full sm:w-1/2">
                <div class="text-center">
                  <vs-button class="mx-2 my-1" v-if="controlButtons" @click="goToPublicPage">Link do udostępniania
                  </vs-button>
                  <vs-button class="mx-2 my-1" @click="downloadFiles">Pobierz pliki</vs-button>
                  <vs-button class="mx-2 my-1" @click="emailModal = true">Email</vs-button>
                  <!--                  <a href="https://man.archlinux.org/man/extra/xdg-utils/xdg-email.1.en"><vs-button class="mx-2 my-1">Edytowalny email</vs-button></a>-->
                  <ComputeClausesButton class="my-1" v-if="agreement && agreement.bank && controlButtons" :id="id"
                                        :bank="agreement.bank"/>
                  <pre>{{ taggedPages ? `Znalezionych klauzul: ${foundClauses}` : 'Brak wyniku' }}</pre>
                </div>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>

    <vs-popup title="Wyślij Email" :active.sync="emailModal">
      <div>
        <div class="p-1">
          <vs-checkbox v-model="customEmailToSend">Zdefiniuj odbiorcę samodzielnie</vs-checkbox>
        </div>
        <div class="p-2">
          <vs-input class="w-full" placeholder="Adres odbiorcy" :disabled="!customEmailToSend" v-model="emailToSend"/>
        </div>
        <div>
<!--          <a v-if="customEmailToSend && emailToSend" title="Wyślij email automatycznie" class="mx-2 my-1 cursor-pointer"><img src="https://preciselab.fra1.digitaloceanspaces.com/emulex/00-images/server.png" alt="Wyślij email automatycznie"></a>-->
          <a v-if="customEmailToSend && emailToSend" :href="mailto" title="Wyślij edytowalny email" class="cursor-pointer">
            <span class="mx-2 my-1"><img src="https://preciselab.fra1.digitaloceanspaces.com/emulex/00-images/email.png" alt="Wyślij edytowalny email"></span>
          </a>
          <SendEmailButton class="my-1" v-if="agreement && controlButtons" :id="id"/>
        </div>
      </div>
    </vs-popup>

    <DetectedClauses :clauseDetections="clauseDetections"/>

    <div class="vx-row" :key="page.id" v-for="(page, index) in pages">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">

        <vs-card :id="`page-${page.page_order}`">
          <div slot="header">
            <h3 class="m-3">
              Strona {{ page.page_order }}
            </h3>
          </div>
          <div style="font-size: 14px; line-height: 27px; text-align: justify" class="m-3" v-if="page.text">

            <div v-if="taggedPages.length > 0 && taggedPages.length === agreement.Page.length">
              <span :key="partIndex" v-for="(textPart, partIndex) in taggedPages[page.page_order-1].parts"
                    v-html="page.text.substring(textPart.start, textPart.end)"
                    :class="{abusive: textPart.isAbusive}"/>
            </div>
            <div v-else>
              <span v-html="page.text">

              </span>
            </div>
          </div>
        </vs-card>

      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">

        <div v-if="page && page.img_url">
          <a :href="page.img_url" target="_blank">
            <img :src="page.img_url" alt="" style="width: 100%">
          </a>
        </div>

      </div>
    </div>

    <div class="vx-row" v-if="agreement.Visit">
      <div class="vx-col w-full mb-base">
        <vs-card>
          <div slot="header">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="m-3">
                Pliki wgrane przez użytkownika:
              </h3>
              <span class="d-flex align-items-center">
                <span class="m-3 agreement-id" title="Identyfikator umowy">{{ id }}</span>
              </span>
            </div>
          </div>
          <div style="font-size: 14px; line-height: 27px; text-align: justify" class="m-3">
            <div class="vx-row">
              <div class="vx-col w-full sm:w-1/1">
                <table class="files-table table table-bordered" style="margin: auto; width: 100%;">
                  <thead>
                  <tr>
                    <th title="Identyfikator i link do pliku">Id pliku</th>
                    <th title="Ilość stron tekstu w pliku.">Strony</th>
                    <th title="Czas między dołączeniem do kolejki a odczytaniem tekstów.">Czas przetwarzania</th>
                    <th title="Plik przeszedł walidację.">Poprawny</th>
                    <th title="Użytkownik wybrał ten plik jako część umowy.">Wybrany</th>
                    <th title="Rozszerzenie pliku">Typ</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="file.file_id" v-for="file in agreement.Visit.File">
                    <td><a :href="file.url" :title="file.url">{{ file.file_id }}</a></td>
                    <td>{{ file.pages }}</td>
                    <td>
                      <span
                        v-if="file.processed_at && file.queued_at">{{
                          new Date(file.processed_at).getTime() / 1000 - new Date(file.queued_at).getTime() / 1000
                        }} sec.</span>
                      <span v-else>Niedostępny</span>
                    </td>
                    <td>
                      <vs-checkbox disabled="true" v-model="file.valid"/>
                    </td>
                    <td>
                      <vs-checkbox disabled="true" v-model="file.selected"/>
                    </td>
                    <td>{{ file.original_type.replace(/.*_/g, '').toUpperCase() }}</td>
                  </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </vs-card>

        <ClientInfoView v-if="showClientInfo" :info-string="agreement.info"/>
      </div>
    </div>


  </div>
</template>

<script>
import SendEmailButton from './SendEmailButton';
import ComputeClausesButton from './ComputeClausesButton';
import DetectedClauses from './DetectedClauses';
import {EVENT_REFRESH_SEARCHES, EventBus} from '../../utils/EventBus';
import {apollo} from '../../plugins/apollo';
import SINGLE_AGREEMENT from '../../graphql/single_agreement.gql'
import COMPUTE_CLAUSE_REPORT from '../../graphql/compute_clause_report.gql';
import ClientInfoView from './ClientInfoView';
import {downloadZip} from "../../utils/downloadZip";
import {dateFormat} from '@/utils/formatters';
import {emailBody} from "../../utils/emailBody";

export default {
  name: "FilesOfAgreement",
  components: {ClientInfoView, ComputeClausesButton, SendEmailButton, DetectedClauses},
  props: {
    id: {
      type: String,
      required: true
    },
    showClientInfo: {
      type: Boolean,
      default: false
    },
    controlButtons: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      agreement: {},
      taggedPages: [],
      clauseDetections: [],
      showAllPages: false,
      emailModal: false,
      emailToSend: '',
      customEmailToSend: true
    }
  },
  computed: {
    mailto() {
      return `mailto:${this.emailToSend}?subject=${this.title}&body=${emailBody(this.agreement, location.origin)}`;
    },
    title() {
      return `Umowa z ${this.agreement.bank} z ${dateFormat(new Date(this.agreement.created_at))} - ${this.agreement.name} ${this.agreement.surname} ${this.agreement.email} ${this.agreement.phone}`
        .replace(/undefined/g, '')
        .replace(/\s+/, ' ')
    },
    pages() {
      if (this.agreement.hasOwnProperty('Page')) {
        const sortedPages = [...new Array(this.agreement.Page.length)]
          .map((p, i) => this.agreement.Page.find(({page_order}) => page_order === i + 1));
        if (this.showAllPages || this.taggedPages.length === 0) {
          return sortedPages;
        } else {
          return sortedPages.filter((p, i) => {
            if (this.taggedPages[i]) {
              return this.taggedPages[i].has_clauses
            } else {
              return false;
            }
          });
        }

      } else {
        return [];
      }
    },
    foundClauses() {
      if (this.taggedPages.length === 0) return 0;
      const parts = this.taggedPages.reduce((prev, next) => prev + Math.max(next.parts.length, 1), 0);
      return (parts - this.taggedPages.length) / 2;
    }
  },
  created() {
    console.log("CREATED");
    this.taggedPages = [];
    this.clauseDetections = [];
    this.agreement = {};
    this.reloadData()
    EventBus.$on(EVENT_REFRESH_SEARCHES, this.reloadTaggedPages);
  },
  destroyed() {
    EventBus.$off(EVENT_REFRESH_SEARCHES);
  },
  methods: {
    async downloadFiles() {
      this.$vs.loading()
      const files = this.agreement.Visit.File;
      console.log("files", files);
      const name = this.title;
      console.log("name", name);
      try {
        await downloadZip(files, name);
      } finally {
        this.$vs.loading.close()
      }
    },
    goToPublicPage() {
      this.$router.push({
        name: 'page-agreement-processed',
        props: {
          id: this.id
        }
      })
    },
    async reloadData() {
      console.log("RELOAD FOR", this.id);

      const {data: {agreement}} = await apollo.query({
        query: SINGLE_AGREEMENT,
        variables: {
          id: this.id
        }
      });

      console.log(this.agreement);

      this.agreement = agreement;
      this.emailToSend = this.agreement.email;
    },
    async reloadTaggedPages() {
      console.log("RELOAD", this.id);
      this.taggedPages = [];
      const out = await apollo.mutate({
        mutation: COMPUTE_CLAUSE_REPORT,
        variables: {
          id: this.id
        }
      })

      console.log("out", out);

      const {data: {computeClauseReport: {pages: taggedPages, clause_detections}}} = out;

      this.taggedPages = taggedPages;
      this.clauseDetections = clause_detections;
    }
  },
  watch: {
    id(newVal, oldVal) {
      console.log("ID", oldVal, newVal);
      this.reloadData();
      this.reloadTaggedPages();
    },
    customEmailToSend(newValue) {
      if(!newValue) {
        this.emailToSend = this.agreement.email;
      }
    }
  }
}
</script>

<style lang="scss">
.abusive {
  /*background-color: #ff8686*/
  background: linear-gradient(118deg, rgba(#ff8686, 1), rgba(#ff8686, 0.7));
  box-shadow: 0 0 10px 1px rgba(#ff8686, 0.5);

}

.agreement-id {
  font-family: monospace;
  letter-spacing: 0.2em;
  color: gray;
}

table.files-table td {
  padding: 5px 10px 3px;
  border: 0;
  text-align: left;
}
</style>
